import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { FaTrashAlt } from 'react-icons/fa';

interface InspectorFooterProps {
  editor?: any
  node?: any
  deleteNode?: any

}


export default class InspectorFooter extends React.Component<InspectorFooterProps, any>{
    constructor(props:InspectorFooterProps) {
      super(props)
      this.state = {showConfirm: false}
      this.deletePressed = this.deletePressed.bind(this)
      this.cancelPressed = this.cancelPressed.bind(this)
      this.deleteConfirmed = this.deleteConfirmed.bind(this)
      this.state = {showConfirm: false}

    }
    
    deletePressed()  { this.setState({showConfirm:true}) }
    cancelPressed()  { this.setState({showConfirm:false}) }
    deleteConfirmed() { this.props.deleteNode(this.props.node)}
    componentWillReceiveProps(nextProps:any) {
      this.setState({showConfirm : false})

      if (!nextProps.editor || !nextProps.editor.state.selectedNode ||
        (nextProps.editor.state.selectedNode && this.props.editor.state.selectedNode && nextProps.editor.state.selectedNode.id != this.props.editor.state.selectedNode.id )
      ) {
        this.setState({showConfirm : false})
      }
    }
    render() {
      
      if (!this.props.deleteNode) {return null; }
        if (this.props.node) {

        let content;
        if (!this.state.showConfirm) {
          content = <div className="deleteNodeButton" onClick={this.deletePressed}><FaTrashAlt /> DELETE THIS NODE</div>
        }  else  {
          content = <div className="confirmView">
                      <div className="confirmText">ARE YOU SURE?</div>
                      <div className="deleteOptions">
                        <span className="editorCancelButton" onClick={this.cancelPressed}>NO, CANCEL</span>
                        <span className="editorDeleteButton" onClick={this.deleteConfirmed}>YES, DELETE</span>
                      </div>
                    </div>
        }


        return (
            <div className="inspectorFooter">
            {content}
            </div>
        );
        }

        return null
     }

};
